module.exports = __webpack_public_path__ + "static/media/albion_alba_icon_medium.4bd8db7d.png";